import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { SharedModule } from "../../shared/shared.module";
import { LinksEffects } from "./links.effects";
import { LinksService } from "./links.service";
import { linksReducer } from "./links.reducer";
import { LinksComponent } from "./links.component";
import { LinkComponent } from "./link/link.component";
import { LinkAddComponent } from "./link-add/link-add.component";
import { LinkEditComponent } from "./link-edit/link-edit.component";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  declarations: [
    LinkComponent,
    LinkAddComponent,
    LinkEditComponent,
    LinksComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    MatDialogModule,
    StoreModule.forFeature("links", linksReducer),
    EffectsModule.forFeature([LinksEffects]),
  ],
  providers: [LinksService],
  exports: [LinkComponent, LinkAddComponent, LinkEditComponent, LinksComponent],
})
export class LinksModule {}
